export default function globalRouter(url, query) {
  let queryString = ''

  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, 'key')) {
      if (queryString !== '') {
        queryString += '&'
      }
      queryString += `${key}=${query[key]}`
    }
  }

  if (query && JSON.stringify(query) !== '{}') {
    return url + '?' + queryString
  } else {
    return url
  }
}

